module.exports = __webpack_public_path__ + "static/img/jiejue4.31678639.png";